var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('HeaderShowcase'),_c('HeroAppShowcase'),_c('BrandLogoCarousel',{staticClass:"pb-0"}),_c('FeatureAppShowcase'),_c('Download'),_c('ThreeStepProcessWrap'),_c('AppShowcaseNewsletter'),_c('FooterAppShowcase'),_c('OverlayMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }